import React, { Component } from 'react';
import axios from "axios";
import Helping from '../../helpers/Helping';
import Notification from "../layout/Notification";
import Pagination from "react-js-pagination";

import {
    LOOKUP,
    MESSAGE
} from '../../config/index';
import { API_URL } from '../../config/urls';
import { connect } from "react-redux";
import { REPORTS } from '../../config/routes';
import { setProfileError, addCurrentRoute } from '../../actions/profile_action';
import { trackPromise } from 'react-promise-tracker';
import Filter from '../layout/Filter';

const { NOT_FOUND } = MESSAGE;
class List extends Component {
    constructor(props) {
        super(props);

        this.state = {
            rows: [],
            url: API_URL.ADMIN_TRADING_API + REPORTS,
            routeName: '',
            error_message: '',
            error_type: '',
            isLoading: true,
            total: 0,
            type: '',
            activePage: 1,
            no_Of_pages: 1,
            limit: LOOKUP.LIMIT,
            search: ''
        };

        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleLimitChange = this.handleLimitChange.bind(this);
        this.pageRefreshFunction = this.pageRefreshFunction.bind(this);
    }

    componentDidMount() {
        const { pathname } = this.props.location;
        this.props.addCurrentRoute(this.props.profile, pathname);

        this.setState({
            routeName: pathname
        });
        this.setErrorOnApiCall();
        this.getWalletHistory();
    }

    getWalletHistory() {
        let { url, search, activePage, limit, type } = this.state,
            body = {
                action: "wallet-history",
                search: search,
                page: activePage,
                limit: limit,
                type: type
            }

        let self = this;
        trackPromise(
            axios.post(url, body, Helping.getConfig()).then(response => {
                let payload = response.data.payload
                self.setState({
                    rows: payload.rows,
                    total: payload.count,
                    isLoading: false,
                    no_Of_pages: Math.ceil(payload.count / limit)
                })
            }).catch(error => {
                self.setState({
                    rows: [],
                    total: 0,
                    isLoading: false
                })
            })
        )

    }

    setErrorOnApiCall = () => {
        setProfileError(res => this.setState({ ...res }));
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest() });
    }

    handlePageChange(pageNumber) {
        if (this.state.activePage === pageNumber) {
            return false;
        }

        this.setErrorOnApiCall();
        this.setState({
            activePage: pageNumber,
            isLoading: true
        },
            () => this.getWalletHistory());
    }

    handleLimitChange(itemsLimit) {
        if (this.state.limit === itemsLimit) {
            return false;
        }
        this.setState({
            limit: itemsLimit,
            activePage: 1,
            isLoading: true
        },
            () => this.getWalletHistory());
    }

    handleSearchChange(e) {
        let $this = this,
            searchValue = e.target.value.replace(/^\s+/g, '');

        if (this.state.search !== searchValue) {
            this.setState({
                search: searchValue,
                activePage: 1
            }, () => {
                if (searchValue.length > 0) {
                    $this.getWalletHistory();
                }

                if (searchValue.length === 0) {
                    $this.getWalletHistory();
                }
            });
        }
    }

    pageRefreshFunction(e) {
        e.preventDefault();
        let self = this

        this.setState({
            search: "",
            type: "",
            activePage: 1,
            error_type: "",
            error_message: ""
        }, () => self.getWalletHistory())
    }

    filteredResults = (e) => {
        e.preventDefault();
        this.setState({
            activePage: 1
        }, () => this.getWalletHistory())
    }

    redirectToTransactionDetailPage = (e, object) => {
        this.props.history.push(`/transaction/${object.id}`);
    }

    render() {
        const data = {
            inputs: [{
                type: 'dropdown',
                label: 'Type',
                name: 'type',
                defaultValue: this.state.type,
                placeholder: 'Select Type...',
                data: [{ "value": 'credit', "name": "Credit" }, { "value": 'debit', "name": "Debit" }]
            }],
            handleValueChange: (e) => this.setState({ type: e.target.value }),
            reset: this.pageRefreshFunction,
            getResults: this.filteredResults
        },
            filtersArray = [this.state.type]

        return (
            <div class="content user-list">
                <div class="top-header">
                    <div class="header-title">
                        <h2 class="title">Users' Wallet</h2>
                        <span class="title-caption">You have total {this.state.total} wallets</span>

                        {/*  SEARCH BAR  */}
                        <form class="listing-search-form" onSubmit={(e) => e.preventDefault()}>
                            <span class="search-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17.999" viewBox="0 0 18 17.999">
                                    <path id="search_Icon" data-name="search Icon" d="M9.583,2a7.579,7.579,0,1,0,4.644,13.56l4.159,4.155a.944.944,0,0,0,1.337.011.973.973,0,0,0,0-1.361L15.56,14.228A7.567,7.567,0,0,0,9.583,2Zm0,1.895A5.684,5.684,0,1,1,3.895,9.579,5.684,5.684,0,0,1,9.579,3.895Z" transform="translate(-2 -2)" />
                                </svg>
                            </span>
                            <input class="form-control" type="search" placeholder="Search in Users' Wallet" aria-label="Search" value={this.state.search} onChange={(e) => this.handleSearchChange(e)} />
                        </form>
                        {/*  SEARCH BAR END  */}
                    </div>

                    <div class="header-btn">
                        <Filter data={data} classes={filtersArray.filter(arr => arr != "").length > 0 ? "filtered" : ""} />

                        <button class="custom-btn icon-btn dark-btn sm-btn" onClick={this.pageRefreshFunction}>
                            <svg id="refresh" xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20">
                                <path id="Path_449" data-name="Path 449" d="M313.164,391.557c-.048-.293-.092-.582-.142-.871a1.127,1.127,0,0,1,.858-1.384,1.064,1.064,0,0,1,1.23.963q.326,1.894.628,3.794a1.1,1.1,0,0,1-.933,1.327l-3.615.643a1.065,1.065,0,0,1-1.262-.888,1.1,1.1,0,0,1,.854-1.288c.438-.095.882-.163,1.378-.252-.108-.068-.173-.113-.242-.151a6.869,6.869,0,0,0-10.015,5.356,7.187,7.187,0,0,0,5.554,8.138,6.961,6.961,0,0,0,8.137-5.977,1.081,1.081,0,0,1,1-.984,1.024,1.024,0,0,1,1.063.8,2.485,2.485,0,0,1-.027.9,9.223,9.223,0,0,1-7.31,7.461,9.074,9.074,0,0,1-10.447-7.421,9.412,9.412,0,0,1,7.2-11.144,8.62,8.62,0,0,1,5.859.9c.053.028.1.056.158.082A.241.241,0,0,0,313.164,391.557Z" transform="translate(-299.689 -389.283)" />
                            </svg>
                            <span class="txt-btn">Refresh</span>
                        </button>
                    </div>
                </div>

                <div class="main-content">
                    {this.state.error_message &&
                        <Notification
                            type={this.state.error_type}
                            message={this.state.error_message}
                            callback={this.removeNetworkError}
                        />
                    }

                    <div class="wallet-history-tbl table-responsive">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col">ID</th>
                                    <th scope="col">Username</th>
                                    <th scope="col">Amount</th>
                                    <th scope="col">Type</th>
                                    <th scope="col">Charge ID</th>
                                    <th scope="col">Created At</th>
                                    <th scope="col">Actions</th>
                                </tr>
                            </thead>

                            {(this.state.total > 0 && !this.state.isLoading) && (
                                <tbody>
                                    {this.state.rows.map((row, i) => (
                                        <tr key={i}>
                                            <td scope="row">{row.id}</td>
                                            <td>{row.user.username}</td>
                                            <td>{parseFloat(row.amount)}</td>
                                            <td>{row.type}</td>
                                            <td>{row.charge_id}</td>
                                            <td>{Helping.convertTimeToHumanReadableFormat(row.created_at)}</td>
                                            <td>
                                                {row.transaction && (
                                                    <span class="action-links">
                                                        <button class="icon more" onClick={(e) => this.redirectToTransactionDetailPage(e, row.transaction)}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16"><path id="view" d="M13.421,8.25a1,1,0,1,1-.688,1.875,2.077,2.077,0,0,0-.72-.125,2,2,0,1,0,2,2,1,1,0,0,1,2,0,3.987,3.987,0,1,1-2.6-3.75Zm6.1-.406a16.737,16.737,0,0,1,1.814,2.562,11.393,11.393,0,0,1,.595,1.188,1.058,1.058,0,0,1,0,.812,11.393,11.393,0,0,1-.595,1.188,16.736,16.736,0,0,1-1.814,2.562A9.8,9.8,0,0,1,12.013,20,9.8,9.8,0,0,1,4.5,16.156a16.744,16.744,0,0,1-1.815-2.562,11.541,11.541,0,0,1-.594-1.188,1.058,1.058,0,0,1,0-.812,11.541,11.541,0,0,1,.594-1.188A16.744,16.744,0,0,1,4.5,7.844,9.8,9.8,0,0,1,12.013,4,9.8,9.8,0,0,1,19.523,7.844ZM6.005,9.156a14.439,14.439,0,0,0-1.564,2.25c-.155.271-.222.411-.313.594.091.183.158.323.313.594a14.439,14.439,0,0,0,1.564,2.25A7.924,7.924,0,0,0,12.013,18a7.924,7.924,0,0,0,6.008-3.156,14.576,14.576,0,0,0,1.564-2.25c.155-.271.222-.411.313-.594-.091-.183-.158-.323-.313-.594a14.576,14.576,0,0,0-1.564-2.25A7.924,7.924,0,0,0,12.013,6,7.924,7.924,0,0,0,6.005,9.156Z" transform="translate(-2.013 -4)"></path></svg>
                                                        </button>
                                                    </span>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            )}
                        </table>
                    </div>

                    {this.state.total > 0 && (
                        <div class="table-bottom">
                            <div class="dataTables_length">
                                <label>Show
                                    <select
                                        name="userDataTable_length"
                                        value={this.state.limit}
                                        onChange={(e) => this.handleLimitChange(e.target.value)}
                                    >
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select> of {this.state.total}</label>
                            </div>
                            <Pagination
                                // hideFirstLastPages
                                activePage={this.state.activePage}
                                itemsCountPerPage={this.state.limit}
                                totalItemsCount={this.state.total}
                                pageRangeDisplayed={5}
                                onChange={this.handlePageChange}
                                itemClass='page-item'
                                linkClass='page-link'
                                prevPageText='Pre'
                                nextPageText='Next'
                                firstPageText='First'
                                lastPageText='Last'
                                innerClass="dataTables_paginate"
                                linkClass="paginate_button"
                                activeLinkClass="paginate_button current"
                                disabledClass="paginate_button disabled"
                            />
                        </div>
                    )}

                    {(this.state.total < 1 && !this.state.isLoading) && (
                        <div className="table-responsive">
                            <Notification type="danger"
                                message={Helping.getMessageString(NOT_FOUND, "Users' Wallets")}
                                callback={this.removeNetworkError} />
                        </div>
                    )}
                </div>
            </div >
        );
    }
}

const mapStateToProps = state => ({
    profile: state.profile,
});

const mapDispatchToProps = {
    addCurrentRoute
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(List);
